<script>
  import { staticUrl } from "../static";
  export let label;
  export let icon;
  export let text;
</script>

<div class="street-tile">
  <div class="label">
    <img class="icon" src="{$staticUrl}img/icon-{icon}.svg" alt={label} width="50" height="50" />
    <span>{label}</span>
  </div>
  <div class="text">{text}</div>
</div>

<style>
  .street-tile {
    width: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .label {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding: 0 0;
    text-transform: uppercase;
    opacity: 0.6;
    font-family: sans-serif;
    font-size: 11px;
    text-align: center;
    height: 60px;
  }

  .icon {
    margin-bottom: 5px;
  }

  .text {
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    padding: 5px 0;
  }
</style>
